import { useTranslation } from 'react-i18next'
import { EN } from '../../i18n/locales/EN.ts'
import { Box } from '../Box.tsx'
import { Button, Typography } from '../generic.tsx'

export const RootError = () => {
	const { t } = useTranslation()

	return (
		<Box flex col full center gap={3}>
			<Typography
				variant='h1'
				sx={{
					fontWeight: 200,
					fontSize: '96px',
					lineHeight: '96px',
					letterSpacing: '0%',
				}}
			>
				{t(($) => $.rootErrorBoundary.title, { defaultValue: EN.translation.rootErrorBoundary.title })}
			</Typography>
			<Typography sx={{ maxWidth: 256, textAlign: 'center' }}>
				{t(($) => $.rootErrorBoundary.subtitle, { defaultValue: EN.translation.rootErrorBoundary.subtitle })}
			</Typography>
			<Button
				onClick={() => {
					globalThis.location.reload()
				}}
			>
				{t(($) => $.rootErrorBoundary.reload, { defaultValue: EN.translation.rootErrorBoundary.reload })}
			</Button>
		</Box>
	)
}
